import fp from 'lodash/fp';
import React from 'react';
import {
  Button,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody
} from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  compose,
  withStateHandlers
} from 'recompose';
import { bindActionCreators } from 'redux';
import {
  businessUserRole
} from '../../../../../constants';
import {
  currentUserSelector,
  userActions
} from '../../../../../state/modules/user';

const TeamMemberPayment = ({
  businessName,
  displayModal,
  showModal,
  hideModal,
  leaveTeam
}) => (
    <Row className='sm-gutter'>
      <Col className='boxed' xs={12} md={6} mdOffset={3}>
        <h2 className='center'>
          Your team pays for your plan
        </h2>
        <p>
          Your account is currently being held under the {businessName} plan
        </p>
        <p>
          <Button bsStyle='plain' className='full' onClick={showModal}>
            Leave team – switch to individual plan
          </Button>
          <Modal show={displayModal} onHide={hideModal}>
            <ModalHeader closeButton>
              <h2 className='center'>
                You are leaving a team plan
              </h2>
            </ModalHeader>
            <ModalBody>
              <p className='center'>
                Are you sure you want to leave the <strong>{businessName}</strong> plan?
              </p>
              <p className='center'>
                You can only join again if you are invited.
              </p>
              <p className='center'>
                To keep adding and monitoring your professional development using Caddie you must continue to pay for your plan yourself.
              </p>
              <p className='center'>
                <Button className='large centered' onClick={() => leaveTeam()}>
                  Yes, I'm sure
                </Button>
              </p>
              <p className='center'>
                <Button
                  bsStyle='plain'
                  className='centered'
                  onClick={hideModal}
                  aria-label='Close'>
                  No, I'll Stay
                </Button>
              </p>
            </ModalBody>
          </Modal>
        </p>
      </Col>
    </Row>
  );

const mapStateToProps = (state) => ({
  businessName: fp.flow(
    currentUserSelector,
    fp.get('roleAssignments'),
    businessUserRole,
    fp.get('businessId'),
    (businessId) => fp.find(({business}) => businessId === business.id)(state.business.businesses),
    fp.get('business.name')
  )(state)
});

const mapDispatchToProps = (dispatch) => ({
  leaveTeam: bindActionCreators(userActions.user.leaveTeam, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers({
    displayModal: false
  }, {
      showModal: () => () => ({
        displayModal: true
      }),
      hideModal: () => () => ({
        displayModal: false
      })
    })
)(TeamMemberPayment);



// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/partials/team-member-payment.js